import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import QuillStyles from "./Quill.module.css";
import Link from "next/link";
import { ParkSafePageSlug } from "@parkschannel/contracts";
import { Button, InsidePageWrapper, OutsidePageWrapper, SimpleImage, Typography } from "@parkschannel/ui";
import { useParkSafe } from "../../ParkSafe";
import { routes, useButtonsAnalytics } from "../../../utils";
import { QuillWrapper } from "../../QuillWrapper";
export const ParkPledgeFAQ = ()=>{
    useButtonsAnalytics();
    const { useParkSafeQuery  } = useParkSafe();
    const { data: page  } = useParkSafeQuery(ParkSafePageSlug.FAQ);
    if (!page) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white",
        children: /*#__PURE__*/ _jsx(OutsidePageWrapper, {
            children: /*#__PURE__*/ _jsxs(InsidePageWrapper, {
                className: "mb-[56px] lg:mt-[70px] lg:gap-10 lg:p-8",
                children: [
                    /*#__PURE__*/ _jsxs("section", {
                        className: "w-full flex flex-col-reverse gap-4 md:justify-between md:flex-row",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        component: "h1",
                                        variant: "h2",
                                        className: "text-neutral-900 mb-4 md:mb-8",
                                        children: page.title
                                    }),
                                    /*#__PURE__*/ _jsx(Link, {
                                        href: routes.parkSafePledge,
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            tabIndex: -1,
                                            size: "md",
                                            variant: "default",
                                            className: "!py-3.5 mb-8 md:mb-0",
                                            children: "Take the pledge"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "shrink-0",
                                children: /*#__PURE__*/ _jsx(SimpleImage, {
                                    src: "/media/park-safe.webp",
                                    alt: "park-safe",
                                    width: 260,
                                    height: 208
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(QuillWrapper, {
                        htmlContent: page.text,
                        className: QuillStyles.quillContainer
                    })
                ]
            })
        })
    });
};
